<ng-template [ngIf]="params">
  <ng-template [ngIf]="params.showDays">{{ params.days }}d&nbsp;</ng-template
  ><ng-template [ngIf]="params.showHours">{{ params.hours }}h&nbsp;</ng-template
  >{{ params.minutes }}m&nbsp;{{ params.seconds }}s
</ng-template>
